import {CtModelRouteData} from "@ctsolution/ct-framework";

export const FormModuleDataRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("formmoduledata");
